import { MockupAsset } from '@api-ui-app/src/app/mockup-studio/types/mockup-studio-assets';
import { Tag } from '@gelato-api-ui/ui-kit/src/lib/tag/tag';

export interface MockupSceneListRequest {
  clientId?: string;
  isPublic?: boolean;
  name?: string;
  tags?: string[];
  offset?: number;
  limit?: number;
  productCategoryUids?: string[];
  productTypeUids?: string[];
  productNameUids?: string[];
}

export interface MockupSceneCreateRequest {
  name: string;
  structure: string;
  isPublic?: boolean;
  clientId: string;
  tags?: string[];
  productCategoryUids: string[];
  productTypeUids?: string[];
  productNameUids?: string[];
}

export interface MockupSceneUpdateRequest {
  id: string;
  name: string;
  structure: string;
  tags?: string[];
  productCategoryUids: string[];
  productTypeUids?: string[];
  productNameUids?: string[];
}

export interface MockupSceneList {
  mockupScenes: MockupScene[];
}

export interface MockupScene {
  id: string;
  name: string;
  structure?: string;
  isPublic?: boolean;
  isStatic?: boolean;
  clientId?: string;
  tags?: string[];
  thumbnailPreview: string;
  mockupAssets?: MockupAsset[];
  deleted?: boolean;
  createdAt: number;
  updatedAt: number;
  categories?: string[];
  productCategoryUids?: MockupSceneProductCategoryUid[];
}

export interface MockupSceneCategory {
  name: string;
  tags: string[];
  scenes: MockupScene[];
  productCategory?: string;
}

export interface MockupSceneTag {
  name: string;
}

export enum DropdownMenuItemId {
  edit = 'edit',
  rename = 'rename',
  duplicate = 'duplicate',
  delete = 'delete',
}

export const SCENE_REQUEST_LIMIT = 50;

export interface MockupSceneListFilter {
  offset?: number;
  clientId?: string;
  name?: string;
  tags?: Tag[];
  filtersOpen?: boolean;
  isPublic?: boolean;
  productCategoryUid?: string;
  productTypeUid?: string;
  productNameUid?: string;
}

export interface ProductCategoryUid {
  categoryName: string;
  categoryTitle: string;
}

export enum MockupSceneProductCategoryUid {
  WallArt = 'wall-art',
  Apparel = 'apparel',
}
